import { getCustomerComments } from 'core/api/customer.api';
import { ICommentError } from 'shared/widgets/Comments/Comments.models';

import {
  getCommentsRequest,
  getCommentsSuccess,
  getCommentsFailure,
} from 'pages/Customers/CustomersComments/GetComments/actionCreators';

const getCommentsAction = (
  controller: AbortController,
  customerId: string | number,
) => async (dispatch) => {
  try {
    const { signal } = controller;

    dispatch(getCommentsRequest());

    const { data } = await getCustomerComments(signal, customerId);

    dispatch(getCommentsSuccess(data));
  } catch (error) {
    const { error: { detail } } = error as ICommentError;
    dispatch(getCommentsFailure(detail));
    throw error;
  }
};

export default getCommentsAction;
